import CloseCircle from '@assets/images/close-circle.svg';
import React, { LegacyRef, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import useBodyScrollLock from '@hooks/useBodyScrollLock';

export type DialogProps = {
	title?: string;
	children?: React.ReactNode;
	showing?: boolean;
	onClose: (showing: boolean) => void;
};

export default function Dialog({ children, title, showing = false, onClose }: DialogProps) {
	const dialogRef = useRef<HTMLDivElement>(null);
	useBodyScrollLock(showing as boolean);

	const onClosePopup = () => {
		onClose(false);
	};

	useEffect(() => {
		if (showing && dialogRef?.current) {
			dialogRef.current.focus();
		}
	}, [showing]);

	if (!showing) return <></>;

	return createPortal(
		<div
			ref={dialogRef as unknown as LegacyRef<HTMLDivElement>}
			data-testid='dialog'
			tabIndex={-1}
			className='w-screen h-screen top-0 left-0 bg-black bg-opacity-80 flex flex-col py-[70px] tablet:py-0 justify-center items-center fixed z-10 overflow-y-auto px-6'>
			<div className='w-full desktop:w-[718px] bg-white rounded-lg relative'>
				<button className='top-[-64px] left-0 absolute'>
					<div className='inline' onClick={onClosePopup}>
						<CloseCircle data-testid='close-button' />
					</div>
				</button>
				<div className='flex justify-center items-center'>
					<p className='text-base font-semibold h-[53px] w-full border-b-[1px] border-b-blue-grey-lighter flex justify-center items-center'>
						{title}
					</p>
				</div>
				{children}
			</div>
		</div>,
		document.body,
	);
}
